module.exports = __webpack_public_path__ + "static/media/neptunemutual.f5f331bf.jpg";